import { Button } from '@/components/ui/button';
import Image from 'next/image';
import Link from 'next/link';

export interface HeroSuaEmpresaProps {
  flag: string;
  titleOrange?: string;
  titleWhite?: string;
  imgSrc?: string;
  description: string;
  buttonText: string;
  hrefButton: string;
}

export default function HeroSuaEmpresa({
  flag,
  titleOrange,
  titleWhite,
  description,
  buttonText,
  hrefButton,
  imgSrc = '/assets/hero-imgs/card-woman.png',
}: HeroSuaEmpresaProps) {
  return (
    <div className="relative h-[23rem] hidden lg:block">
      <div className="absolute inset-0 flex">
        <div className="w-1/2 bg-bluecaixa rounded-l-2xl flex items-center px-4 lg:pl-12">
          <div className="text-white space-y-4">
            {/* Texto com borda arredondada */}
            <div className="inline-block px-4 py-1 border-2 border-white rounded-full text-xs lg:text-sm">
              {flag}
            </div>

            {/* Título h1 com metade colorida */}
            <h1 className="text-2xl lg:text-5xl font-extrabold leading-snug lg:pr-36">
              <span className="text-orangecaixa">{titleOrange}</span>
              <span className="text-white"> {titleWhite}</span>
            </h1>
          </div>
        </div>
        <div className="w-1/2 bg-orangecaixa rounded-r-2xl flex flex-col justify-center lg:pl-48 px-6 text-white space-y-4">
          <p className="text-xs lg:text-base font-thin leading-relaxed mb-2">
            {description}
          </p>

          <Button
            key={'Test'}
            variant={'ghost'}
            asChild
            className="text-white p-4 lg:p-8 lg:w-fit bg-bluecaixa"
          >
            <Link
              key={'para sua empresa'}
              href={hrefButton}
              className="flex items-center lg:gap-2 text-xs lg:text-sm lg:font-semibold text-white hover:text-stone-200"
            >
              <Image
                height={24}
                width={24}
                src={'/icons/arrow-right-circle.png'}
                alt={'right arrow icon'}
              />
              {buttonText}
            </Link>
          </Button>
        </div>

        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-10 lg:w-[384px] max-w-[768px]">
          <div className="relative w-full aspect-[768/964]">
            <Image src={imgSrc} alt="Imagem Central" fill priority={false} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function BannerStaticDesktop({
  flag,
  titleOrange,
  titleWhite,
  description,
  buttonText,
  imgSrc = '',
  hrefButton,
}: HeroSuaEmpresaProps) {
  return (
    <div className="relative h-[482px] hidden lg:block">
      <Link href={hrefButton} className="w-full h-full">
        <Image
          src={imgSrc}
          alt={`flag: ${flag} - title: ${titleOrange} ${titleWhite} - description: ${description} - ${buttonText}`}
          fill
          style={{ objectFit: 'cover' }}
          sizes="(max-width: 1280px) 100vw, 1280px"
          priority={false}
        />
      </Link>
    </div>
  );
}
